package com.evoapps.evoshift.viewmodels

import com.evoapps.evoshift.domain.market.Market
import com.evoapps.evoshift.domain.repository.WorkplaceRepository
import com.evoapps.evoshift.domain.staffing.LabourTarget

/** The currency of workplaces created before it was a setting, and of screens without the repository. */
const val DEFAULT_CURRENCY = "PLN"

/** The workplace's currency (its settings), for formatting amounts; [DEFAULT_CURRENCY] if unknown. */
suspend fun WorkplaceRepository?.currencyOf(workplaceId: String): String =
    this?.getWorkplace(workplaceId)?.getOrNull()?.settings?.currency?.takeIf { it.isNotBlank() } ?: DEFAULT_CURRENCY

/**
 * SH-95: the workplace's labour target (% of income, or its default for the commission), for
 * colouring labour % against it; null when the financial settings cannot be read.
 */
suspend fun WorkplaceRepository?.labourTargetOf(workplaceId: String): LabourTarget? {
    val repository = this ?: return null
    val financials = repository.getWorkplaceFinancials(workplaceId).getOrNull() ?: return null
    val market = repository.getWorkplace(workplaceId).getOrNull()?.settings?.market ?: Market.POLAND
    return financials.labourTarget(market)
}
